import { render, staticRenderFns } from "./ai-coach-disclaimer.vue?vue&type=template&id=22a77762&scoped=true"
import script from "./ai-coach-disclaimer.vue?vue&type=script&lang=js"
export * from "./ai-coach-disclaimer.vue?vue&type=script&lang=js"
import style0 from "./ai-coach-disclaimer.vue?vue&type=style&index=0&id=22a77762&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a77762",
  null
  
)

export default component.exports